export const mockPayslips = [
  {
    id: 'PS-001',
    userId: 'NV001',
    month: 12,
    year: 2025,
    periodStart: '2025-12-01',
    periodEnd: '2025-12-31',
    status: 'confirmed' as const,
    confirmedAt: '2025-12-05',
    disputedReason: null,

    agreedSalary: 16000000,
    standardDays: 25,
    actualDays: 21,
    monthlySalary: 13440000,
    otWeekdayHours: 0,
    otWeekend2xHours: 0,
    otWeekend3xHours: 0,
    otHolidayHours: 0,
    unpaidLeaveDays: 2.5,
    annualLeaveDays: 3,
    overtimePay: 0,
    commission: 0,
    kpi: 0,
    businessTrip: 0,
    eventSupport: 0,
    mealTransportAllowance: 1000000,
    otherAllowance: 726667,

    grossSalary: 15166667,
    insuranceTotal: 577500,
    tax: 0,
    advance: 0,
    latePenaltyMinutes: 0,
    attendanceBonusDeduct: 0,
    forgotPunchCount: 0,
    forgotPunchDeduct: 0,
    otherDeduction: 0,

    netIncome: 14589167,
    note: 'Công tiền phép năm 0,49 ngày',

    createdAt: '2025-12-01',
  },
  {
    id: 'PS-002',
    userId: 'NV001',
    month: 11,
    year: 2025,
    periodStart: '2025-11-01',
    periodEnd: '2025-11-30',
    status: 'confirmed' as const,
    confirmedAt: '2025-11-05',
    disputedReason: null,

    agreedSalary: 16000000,
    standardDays: 24,
    actualDays: 24,
    monthlySalary: 16000000,
    otWeekdayHours: 8,
    otWeekend2xHours: 4,
    otWeekend3xHours: 0,
    otHolidayHours: 0,
    unpaidLeaveDays: 0,
    annualLeaveDays: 0,
    overtimePay: 2285714,
    commission: 1500000,
    kpi: 500000,
    businessTrip: 0,
    eventSupport: 500000,
    mealTransportAllowance: 1000000,
    otherAllowance: 0,

    grossSalary: 21785714,
    insuranceTotal: 577500,
    tax: 350000,
    advance: 0,
    latePenaltyMinutes: 15,
    attendanceBonusDeduct: 0,
    forgotPunchCount: 0,
    forgotPunchDeduct: 0,
    otherDeduction: 0,

    netIncome: 20858214,
    note: 'Tháng 11 đạt KPI, có tăng ca cuối tuần',

    createdAt: '2025-11-01',
  },
  {
    id: 'PS-003',
    userId: 'NV001',
    month: 10,
    year: 2025,
    periodStart: '2025-10-01',
    periodEnd: '2025-10-31',
    status: 'confirmed' as const,
    confirmedAt: '2025-10-06',
    disputedReason: null,

    agreedSalary: 16000000,
    standardDays: 26,
    actualDays: 25,
    monthlySalary: 15384615,
    otWeekdayHours: 0,
    otWeekend2xHours: 0,
    otWeekend3xHours: 0,
    otHolidayHours: 0,
    unpaidLeaveDays: 0,
    annualLeaveDays: 1,
    overtimePay: 0,
    commission: 800000,
    kpi: 0,
    businessTrip: 0,
    eventSupport: 0,
    mealTransportAllowance: 1000000,
    otherAllowance: 0,

    grossSalary: 17184615,
    insuranceTotal: 577500,
    tax: 150000,
    advance: 0,
    latePenaltyMinutes: 0,
    attendanceBonusDeduct: 200000,
    forgotPunchCount: 1,
    forgotPunchDeduct: 50000,
    otherDeduction: 0,

    netIncome: 16357115,
    note: 'Trừ thưởng chuyên cần do nghỉ ốm không báo trước',

    createdAt: '2025-10-01',
  },
  {
    id: 'PS-004',
    userId: 'NV001',
    month: 9,
    year: 2025,
    periodStart: '2025-09-01',
    periodEnd: '2025-09-30',
    status: 'pending' as const,
    confirmedAt: null,
    disputedReason: null,

    agreedSalary: 16000000,
    standardDays: 25,
    actualDays: 22,
    monthlySalary: 14080000,
    otWeekdayHours: 0,
    otWeekend2xHours: 0,
    otWeekend3xHours: 0,
    otHolidayHours: 0,
    unpaidLeaveDays: 1,
    annualLeaveDays: 2,
    overtimePay: 0,
    commission: 1200000,
    kpi: 300000,
    businessTrip: 0,
    eventSupport: 0,
    mealTransportAllowance: 1000000,
    otherAllowance: 0,

    grossSalary: 16580000,
    insuranceTotal: 577500,
    tax: 250000,
    advance: 2000000,
    latePenaltyMinutes: 0,
    attendanceBonusDeduct: 0,
    forgotPunchCount: 0,
    forgotPunchDeduct: 0,
    otherDeduction: 0,

    netIncome: 13752500,
    note: 'Tạm ứng 2 triệu ngày 15/09',

    createdAt: '2025-09-01',
  },
  {
    id: 'PS-005',
    userId: 'NV003',
    month: 12,
    year: 2025,
    periodStart: '2025-12-01',
    periodEnd: '2025-12-31',
    status: 'pending' as const,
    confirmedAt: null,
    disputedReason: null,

    agreedSalary: 12000000,
    standardDays: 25,
    actualDays: 23,
    monthlySalary: 11040000,
    otWeekdayHours: 4,
    otWeekend2xHours: 6,
    otWeekend3xHours: 0,
    otHolidayHours: 0,
    unpaidLeaveDays: 0.5,
    annualLeaveDays: 1.5,
    overtimePay: 1714286,
    commission: 0,
    kpi: 0,
    businessTrip: 0,
    eventSupport: 0,
    mealTransportAllowance: 800000,
    otherAllowance: 500000,

    grossSalary: 14054286,
    insuranceTotal: 433125,
    tax: 0,
    advance: 0,
    latePenaltyMinutes: 30,
    attendanceBonusDeduct: 0,
    forgotPunchCount: 0,
    forgotPunchDeduct: 0,
    otherDeduction: 0,

    netIncome: 13621161,
    note: 'Phạt đi trễ 30 phút tháng 12',

    createdAt: '2025-12-01',
  },
  {
    id: 'PS-006',
    userId: 'NV003',
    month: 11,
    year: 2025,
    periodStart: '2025-11-01',
    periodEnd: '2025-11-30',
    status: 'disputed' as const,
    confirmedAt: null,
    disputedReason: 'Số giờ tăng ca không đúng, đề nghị kiểm tra lại ngày 08/11',

    agreedSalary: 12000000,
    standardDays: 24,
    actualDays: 24,
    monthlySalary: 12000000,
    otWeekdayHours: 0,
    otWeekend2xHours: 0,
    otWeekend3xHours: 0,
    otHolidayHours: 0,
    unpaidLeaveDays: 0,
    annualLeaveDays: 0,
    overtimePay: 0,
    commission: 0,
    kpi: 0,
    businessTrip: 0,
    eventSupport: 0,
    mealTransportAllowance: 800000,
    otherAllowance: 0,

    grossSalary: 12800000,
    insuranceTotal: 433125,
    tax: 0,
    advance: 0,
    latePenaltyMinutes: 0,
    attendanceBonusDeduct: 0,
    forgotPunchCount: 0,
    forgotPunchDeduct: 0,
    otherDeduction: 0,

    netIncome: 12366875,
    note: '',

    createdAt: '2025-11-01',
  },
];

export type PayslipStatus = 'pending' | 'confirmed' | 'disputed';

export interface Payslip {
  id: string;
  userId: string;
  month: number;
  year: number;
  periodStart: string;
  periodEnd: string;
  status: PayslipStatus;
  confirmedAt: string | null;
  disputedReason: string | null;

  agreedSalary: number;
  standardDays: number;
  actualDays: number;
  monthlySalary: number;
  otWeekdayHours: number;
  otWeekend2xHours: number;
  otWeekend3xHours: number;
  otHolidayHours: number;
  unpaidLeaveDays: number;
  annualLeaveDays: number;
  overtimePay: number;
  commission: number;
  kpi: number;
  businessTrip: number;
  eventSupport: number;
  mealTransportAllowance: number;
  otherAllowance: number;

  grossSalary: number;
  insuranceTotal: number;
  tax: number;
  advance: number;
  latePenaltyMinutes: number;
  attendanceBonusDeduct: number;
  forgotPunchCount: number;
  forgotPunchDeduct: number;
  otherDeduction: number;

  netIncome: number;
  note: string;

  createdAt: string;
}

export const payslipStatusLabels: Record<PayslipStatus, string> = {
  pending: 'Chờ xác nhận',
  confirmed: 'Đã xác nhận',
  disputed: 'Khiếu nại',
};

export const payslipStatusColors: Record<PayslipStatus, string> = {
  pending: 'bg-secondary-100 text-secondary-700',
  confirmed: 'bg-accent-100 text-accent-700',
  disputed: 'bg-primary-100 text-primary-700',
};

export const payslipStatusIcon: Record<PayslipStatus, string> = {
  pending: 'ri-time-line',
  confirmed: 'ri-check-double-line',
  disputed: 'ri-error-warning-line',
};